document.addEventListener('DOMContentLoaded', () => {
    const openSubmenus = [];
    const hoverDelay = 400;
    const fadeDuration = 100;
    let hoverTimeout;

    function closeSubmenu(button, submenu) {
        if (!button || !submenu) return;
        button.setAttribute('aria-expanded', 'false');
        submenu.style.transition = `opacity ${fadeDuration}ms ease`;
        submenu.style.opacity = 0;
        setTimeout(() => {
            submenu.style.display = 'none';
            submenu.setAttribute('hidden', 'hidden');
            submenu.querySelectorAll('a').forEach(link => link.classList.remove('submenu_background-color'));
        }, fadeDuration);
        openSubmenus.splice(openSubmenus.findIndex(item => item.button === button), 1);
        button.closest('li.button-shop_by_department')?.classList.remove('submenu_background-color');
    }

    function closeAllSubmenus() {
        while (openSubmenus.length) {
            const { button, submenu } = openSubmenus.pop();
            closeSubmenu(button, submenu);
        }
    }

    function handleHoverState(button, submenu) {
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(() => {
            if (!button || !submenu) return;
            button.setAttribute('aria-expanded', 'true');
            submenu.style.display = 'grid';
            submenu.style.transition = `opacity ${fadeDuration}ms ease`;
            submenu.style.opacity = 1;
            submenu.removeAttribute('hidden');
            openSubmenus.push({ button, submenu });
            button.closest('li.button-shop_by_department')?.classList.add('submenu_background-color');
        }, hoverDelay);
    }

    document.querySelectorAll('.header-menu > button').forEach(button => {
        const submenu = button.nextElementSibling;

        button.addEventListener('click', () => {
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
                closeSubmenu(button, submenu);
            } else {
                closeAllSubmenus();
                button.setAttribute('aria-expanded', 'true');
                submenu.style.display = 'grid';
                submenu.style.transition = `opacity ${fadeDuration}ms ease`;
                submenu.style.opacity = 1;
                submenu.removeAttribute('hidden');
                openSubmenus.push({ button, submenu });
            }
        });

        button.addEventListener('mouseover', () => handleHoverState(button, submenu));
        button.addEventListener('mouseleave', (event) => {
            clearTimeout(hoverTimeout);
            if (!submenu.contains(event.relatedTarget) && !button.contains(event.relatedTarget)) {
                closeSubmenu(button, submenu);
            }
        });

        submenu.addEventListener('mouseleave', (event) => {
            clearTimeout(hoverTimeout);
            if (!submenu.contains(event.relatedTarget) && !button.contains(event.relatedTarget)) {
                closeSubmenu(button, submenu);
            }
        });

        submenu.addEventListener('mouseover', () => {
            clearTimeout(hoverTimeout);
            button.setAttribute('aria-expanded', 'true');
            submenu.style.display = 'grid';
            submenu.style.transition = `opacity ${fadeDuration}ms ease`;
            submenu.style.opacity = 1;
            submenu.removeAttribute('hidden');
        });

        button.addEventListener('keydown', (event) => {
            if (event.key === 'Tab' && event.shiftKey) {
                closeAllSubmenus();
            }
        });

        submenu.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                if (openSubmenus.length) {
                    const { button } = openSubmenus[openSubmenus.length - 1];
                    button.focus();
                    closeAllSubmenus();
                }
            }
        });

        button.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                if (openSubmenus.length) {
                    const { button } = openSubmenus[openSubmenus.length - 1];
                    button.focus();
                    closeAllSubmenus();
                }
            }
        });
    });

    document.querySelectorAll('.submenu > button').forEach(button => {
        const submenu = button.nextElementSibling;
        const buttonParent = button.closest('.button-shop_by_department');

        if (!button || !submenu || !buttonParent) return;

        const mouseLeaveDelay = 500;

        let mouseOverTimeout;
        let mouseLeaveTimeout;

        const closeSubmenuLocal = (button, submenu) => {
            if (!button || !submenu) return;
            button.setAttribute('aria-expanded', 'false');
            submenu.style.transition = `opacity ${fadeDuration}ms ease`;
            submenu.style.opacity = 0;
            setTimeout(() => {
                submenu.style.display = 'none';
                submenu.setAttribute('hidden', 'hidden');
            }, fadeDuration);
            button.closest('.button-shop_by_department')?.classList.remove('submenu_background-color');
            openSubmenus.splice(openSubmenus.findIndex(item => item.button === button), 1);
        };

        const handleHoverStateLocal = (button, submenu) => {
            button.setAttribute('aria-expanded', 'true');
            submenu.style.display = 'grid';
            submenu.style.transition = `opacity ${fadeDuration}ms ease`;
            submenu.style.opacity = 1;
            submenu.removeAttribute('hidden');
            button.closest('.button-shop_by_department')?.classList.add('submenu_background-color');
            openSubmenus.push({ button, submenu });
        };

        button.addEventListener('click', (event) => {
            event.stopPropagation();
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
                closeSubmenuLocal(button, submenu);
            } else {
                closeSubmenuLocal(buttonParent.querySelector('button[aria-expanded="true"]'), buttonParent.querySelector('.header__submenu[aria-expanded="true"]'));
                handleHoverStateLocal(button, submenu);
            }
        });

        buttonParent.addEventListener('click', (event) => {
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            if (!isExpanded) {
                document.querySelectorAll('.submenu > button[aria-expanded="true"]').forEach(otherButton => {
                    if (otherButton !== button) {
                        closeSubmenuLocal(otherButton, otherButton.nextElementSibling);
                    }
                });
                handleHoverStateLocal(button, submenu);
            }
        });

        const handleMouseOver = () => {
            clearTimeout(mouseOverTimeout);
            clearTimeout(mouseLeaveTimeout);
            mouseOverTimeout = setTimeout(() => handleHoverStateLocal(button, submenu), hoverDelay);
        };

        button.addEventListener('mouseover', handleMouseOver);
        buttonParent.addEventListener('mouseover', handleMouseOver);

        const handleMouseLeave = (event) => {
            clearTimeout(mouseOverTimeout);
            clearTimeout(mouseLeaveTimeout);
            mouseLeaveTimeout = setTimeout(() => {
                if (!submenu.contains(event.relatedTarget) && !buttonParent.contains(event.relatedTarget)) {
                    closeSubmenuLocal(button, submenu);
                    buttonParent.classList.remove('submenu_background-color');
                }
            }, mouseLeaveDelay);
        };

        button.addEventListener('mouseleave', handleMouseLeave);
        buttonParent.addEventListener('mouseleave', handleMouseLeave);

        submenu.addEventListener('mouseover', () => {
            clearTimeout(mouseOverTimeout);
            clearTimeout(mouseLeaveTimeout);
            handleHoverStateLocal(button, submenu);
        });

        submenu.addEventListener('mouseleave', (event) => {
            clearTimeout(mouseOverTimeout);
            clearTimeout(mouseLeaveTimeout);
            mouseLeaveTimeout = setTimeout(() => {
                if (!submenu.contains(event.relatedTarget) && !button.contains(event.relatedTarget)) {
                    closeSubmenuLocal(button, submenu);
                    buttonParent.classList.remove('submenu_background-color');
                }
            }, mouseLeaveDelay);
        });

        button.addEventListener('keydown', (event) => {
            if (event.key === 'Tab') {
                const focusableElements = submenu.querySelectorAll('a, button');
                const lastElement = focusableElements[focusableElements.length - 1];
                if (event.shiftKey) {
                    if (document.activeElement === button) {
                        closeSubmenuLocal(button, submenu);
                        buttonParent.classList.remove('submenu_background-color');
                    }
                } else if (document.activeElement === lastElement) {
                    closeSubmenuLocal(button, submenu);
                    buttonParent.classList.remove('submenu_background-color');
                }
            }
        });

        submenu.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                if (openSubmenus.length) {
                    const { button } = openSubmenus[openSubmenus.length - 1];
                    button.focus();
                    closeAllSubmenus();
                }
            }
        });
    });

    document.querySelectorAll('.header__submenu').forEach(submenu => {
        const updateFocusableElements = () => {
            let focusableElements = Array.from(submenu.querySelectorAll('a, button'));

            const hiddenSubmenus = submenu.querySelectorAll('.header__submenu[hidden], .header__submenu[style*="display: none"]');
            hiddenSubmenus.forEach(innerSubmenu => {
                const innerFocusableElements = Array.from(innerSubmenu.querySelectorAll('a, button'));
                focusableElements = focusableElements.filter(element => !innerFocusableElements.includes(element));
            });

            return focusableElements;
        };

        const setFocusHandlers = () => {
            const focusableElements = updateFocusableElements();
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            if (firstElement) {
                firstElement.addEventListener('keydown', (event) => {
                    if (event.key === 'Tab' && event.shiftKey) {
                        const button = submenu.previousElementSibling;
                        closeSubmenu(button, submenu);
                        button.focus();
                        event.preventDefault();
                    }
                });
            }

            if (lastElement) {
                lastElement.addEventListener('keydown', (event) => {
                    if (event.key === 'Tab' && !event.shiftKey) {
                        event.preventDefault();
                        handleLastElementTab(lastElement);
                    }
                });
            }
        };

        const handleLastElementTab = (lastElement) => {
            const openInnerSubmenu = submenu.querySelector('.header__submenu:not([hidden])');
            if (openInnerSubmenu) {
                const innerFocusableElements = Array.from(openInnerSubmenu.querySelectorAll('a, button'));
                if (innerFocusableElements.length) {
                    innerFocusableElements[0].focus();
                    return;
                }
            }

            const button = submenu.previousElementSibling;
            closeSubmenu(button, submenu);

            let nextHeader = submenu.closest('li').nextElementSibling?.querySelector('button, a');
            if (!nextHeader) {
                let parentSubmenu = submenu.closest('.header__submenu');
                while (parentSubmenu) {
                    const parentButton = parentSubmenu.previousElementSibling;
                    const parentLi = parentButton.closest('li');
                    nextHeader = parentLi.nextElementSibling?.querySelector('button, a');
                    if (nextHeader) {
                        break;
                    }
                    parentSubmenu = parentLi.closest('.header__submenu');
                }
            }

            if (nextHeader) {
                nextHeader.focus();
            }
        };


        submenu.addEventListener('transitionend', setFocusHandlers);
        setFocusHandlers();
    });

    document.addEventListener('click', (event) => {
        if (!event.target.closest('.header-menu') && !event.target.closest('.submenu')) {
            closeAllSubmenus();
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const submenus = document.querySelectorAll('.submenu2-shop_by_department');

    submenus.forEach(function (submenu) {
        submenu.addEventListener('click', function (event) {
            event.stopPropagation();
        });
    });
});
